// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eR","menuControls_styleDefault":"c-a_eS","menuControls_styleRed":"c-a_eT"};